import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaFileExport } from 'react-icons/fa';
import { downloadFolders, hasAccess } from '../../../utils';
import PositionalModal from '../../../lib/PositionalModal';
import Loader from '../../Loader';
import MoveFolderToCaseModal from '../../MoveFolderToCaseModal';
import withModalConfirm from '../../../lib/withModalConfirm';
import folderImg from '../../../assets/images/icons/folder-filled.svg';
import dots from '../../../assets/images/icons/green-dots.svg';
// import mailIcon from '../../../assets/images/icons/mail.svg';
import deleteIcon from '../../../assets/images/icons/delete.svg';
import downloadIcon from '../../../assets/images/icons/download.svg';
import renameIcon from '../../../assets/images/icons/rename.svg';
import moveFolderIcon from '../../../assets/images/icons/folder-move-to.svg';

import styles from './folders-list.module.scss';

const FolderItem = ({
  folder,
  handleClickFolder,
  actions = {},
  initOptsMove = [],
  onMoved,
  confirm,
}) => {
  const { user } = useSelector((store) => store).authReducer;
  const modalRef = useRef();
  const moveModalRef = useRef();
  const modalParent = useRef();
  const inputNameRef = useRef();
  const dispatch = useDispatch();
  const [editName, setEditName] = useState(false);
  const [valueName, setValueName] = useState(folder.name);
  const [isLoading, setIsLoading] = useState(false);
  const [optsMove, setOptsMove] = useState(null);

  // FOCUS ON FIELD WHEN IT BECOMES EDITABLE
  useEffect(() => {
    if (!editName) return;
    inputNameRef.current.focus();
  }, [editName]);

  useEffect(() => {
    setValueName(folder.name);
  }, [folder.name]);

  // SET POSITION MODAL WHEN LIST CASE OPEN CHANGE
  useEffect(() => {}, []);

  // INIT OPTIONS MOVE
  useEffect(() => {
    setOptsMove(initOptsMove);
  }, [initOptsMove]);

  function openModal(e) {
    e.preventDefault();
    e.stopPropagation();
    modalRef.current.open();
  }

  async function saveName() {
    if (!actions.rename || typeof actions?.rename !== 'function') return;
    setIsLoading(true);
    setEditName(false);
    await actions.rename(dispatch, {
      _id: folder._id,
      name: valueName,
    });
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }

  function renameActive(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!actions.rename) return;
    modalRef.current.close();
    setEditName(true);
  }

  function deleteFolder(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!actions.delete || typeof actions.delete !== 'function') return;
    modalRef.current.close();
    const doDelete = () => actions.delete(folder);
    if (confirm) {
      confirm(doDelete, `Êtes vous sûr de vouloir supprimer le dossier « ${folder.name} » ?`);
      return;
    }
    doDelete();
  }

  function moveFolder(data) {
    if (!actions.move) return null;
    return actions.move(dispatch, data);
  }

  function copyFolder(targetFolder, caseId) {
    if (!actions.copy) return null;
    return actions.copy(targetFolder, caseId);
  }

  function openMoveModal(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!moveModalRef.current?.open) return;
    moveModalRef.current.open();
    modalRef.current.close();
  }

  /* function sendFolder(e) {
    e.preventDefault();
    e.stopPropagation();
    modalRef.current.close();
    actions.send({ _id: folder._id, name: valueName, type: 'folder' });
  } */

  function dowloadFolder(e) {
    e.preventDefault();
    e.stopPropagation();
    downloadFolders(valueName, [{ _id: folder._id, type: 'folder' }]);
  }

  function submitName(e) {
    if (e.key === 'Enter') {
      inputNameRef.current.blur();
    } else if (e.key === 'Escape') {
      setValueName(folder.name);
      inputNameRef.current.blur();
      setEditName(false);
    }
  }

  function handleBlur() {
    saveName();
  }

  return (
    <li>
      <PositionalModal
        ref={modalRef}
        parent={modalParent}
        alignmentX={'right'}
        alignmentY={'middle'}
      >
        <div className={styles.containerActions} data-close-modal='false' onClick={(e) => e.stopPropagation()}>
          {(hasAccess(user.role) && actions.move) && (
            <div className={styles.moveAction} onClick={openMoveModal}>
              <img src={moveFolderIcon} alt="Déplacer vers une affaire" />
              <p>Déplacer vers une affaire</p>
              {!optsMove && <div className={styles.loader}><Loader size={18} /></div>}
            </div>
          )}
          {(hasAccess(user.role) && folder.isEditable !== false && actions.rename) && (
            <div onClick={(e) => renameActive(e)}>
              <img src={renameIcon} alt='Renommer' />
              <p>Renommer</p>
            </div>
          )}
          {actions.print && (<div onClick={(e) => dowloadFolder(e)}>
            <FaFileExport size='20px' />
            <p>Télécharger</p>
          </div>
          )}
          {/* actions.send && (
            <div onClick={(e) => sendFolder(e)}>
              <img src={mailIcon} alt='Envoyer par mail' />
              <p>Envoyer par mail</p>
            </div>
          )} */}
          {actions.download && (<div><img src={downloadIcon} alt='Télécharger' /><p>Télécharger</p></div>)}
          {(hasAccess(user.role) && folder.isEditable && actions.delete) && (
            <div onClick={(e) => deleteFolder(e)}>
              <img src={deleteIcon} alt='Supprimer' />
              <p>Supprimer</p>
            </div>
          )}
        </div>
      </PositionalModal>

      {(hasAccess(user.role) && actions.move) && (
        <MoveFolderToCaseModal
          ref={moveModalRef}
          folder={folder}
          initOptsMove={optsMove || []}
          onMove={moveFolder}
          onCopy={actions.copy ? copyFolder : null}
          onMoved={onMoved}
        />
      )}
      <div
        style={handleClickFolder && !editName ? { cursor: 'pointer' } : {}}
        onClick={handleClickFolder && !editName
          ? () => handleClickFolder(folder._id)
          : undefined}
      >
        {isLoading
          ? <div className={styles.loader}><Loader size={20} /></div>
          : <img src={folderImg} alt={`dossier ${folder.name}`} />
        }
        {!editName
          ? <p>{valueName}</p>
          : <input
            ref={inputNameRef}
            type='text'
            value={valueName}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={submitName}
            onBlur={handleBlur}
            onChange={(e) => setValueName(e.target.value)}
          />
        }
      </div>
      <div className={styles.toggle} ref={modalParent}>
        <span onClick={openModal}>
          <img src={dots} alt={`action sur le dossier: ${folder.name}`} />
        </span>
      </div>
    </li>
  );
};

const FoldersList = ({
  folders,
  handleClickFolder,
  actions,
  initOptsMove = [],
  onMoved,
  confirm,
}) => (
  <div className={styles.foldersList}>
    {(folders) && (
      <ul>
        {folders.map((folder) => (
          <FolderItem
            actions={actions}
            initOptsMove={initOptsMove}
            key={`folder-${folder._id}`}
            folder={folder}
            handleClickFolder={handleClickFolder}
            onMoved={onMoved}
            confirm={confirm}
          />
        ))}
      </ul>
    )}
  </div>
);

export default withModalConfirm(FoldersList);
